import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type BbfcUProps = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const BbfcU = ({ height = 35, sx, width = 35 }: BbfcUProps) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 82.491" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M42.52 273.902h62.843v55.985H42.52Zm0 0" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" style={{ opacity: 1, stopOpacity: 1 }} transform="translate(-62.655 -403.612) scale(1.47356)">
      <path
        d="M103.715 326.453a4.85 4.85 0 0 1-4.246 2.45H48.414a4.85 4.85 0 0 1-4.246-2.45 4.85 4.85 0 0 1 0-4.902l25.527-44.219a4.85 4.85 0 0 1 4.246-2.45 4.85 4.85 0 0 1 4.246 2.45l25.528 44.219a4.85 4.85 0 0 1 0 4.902m.851-5.394-25.53-44.215a5.814 5.814 0 0 0-5.095-2.942 5.823 5.823 0 0 0-5.093 2.938l-25.532 44.219a5.827 5.827 0 0 0 0 5.882 5.825 5.825 0 0 0 5.098 2.942H99.47a5.825 5.825 0 0 0 5.097-2.942 5.827 5.827 0 0 0 0-5.882"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M99.469 326.445H48.414c-1.883 0-3.062-2.035-2.121-3.668l25.531-44.215a2.416 2.416 0 0 1 2.117-1.222c.825 0 1.649.406 2.118 1.223l25.527 44.214c.945 1.633-.234 3.668-2.117 3.668m4.246-4.894-25.528-44.219a4.85 4.85 0 0 0-4.246-2.45 4.85 4.85 0 0 0-4.246 2.45l-25.527 44.219a4.85 4.85 0 0 0 0 4.902 4.85 4.85 0 0 0 4.246 2.45H99.47a4.85 4.85 0 0 0 4.246-2.45 4.85 4.85 0 0 0 0-4.902"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="translate(-62.655 -403.612) scale(1.47356)"
    />
    <path
      d="M76.059 278.563a2.416 2.416 0 0 0-2.118-1.223c-.824 0-1.648.406-2.117 1.223l-25.531 44.214c-.941 1.633.238 3.668 2.121 3.668H99.47c1.883 0 3.062-2.035 2.117-3.668zm0 0"
      style={{
        fill: '#2ea635',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="translate(-62.655 -403.612) scale(1.47356)"
    />
    <path
      d="M81.828 300.875v12.332c-.027 2.219-.027 4.05-2.11 5.824-1.991 1.746-4.57 1.91-5.902 1.91-1.191 0-2.355-.136-3.464-.527-2.329-.8-3.579-2.492-4.02-3.96-.25-.86-.25-1.47-.277-3.911v-11.668h3.66v12.027c0 .832-.027 1.637.25 2.387.746 1.883 2.8 2.106 3.96 2.106.587 0 2.055-.028 3.134-.97 1.082-.972 1.082-2.081 1.082-3.714v-11.836Zm0 0"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="translate(-62.655 -403.612) scale(1.47356)"
    />
  </SvgContainer>
);
